import { FC, useEffect } from 'react';
import { IDataShopping } from '../../types/orders';
import './SecondShoppingHeader.scss';

interface IShoppingHeader {
  headerData?: IDataShopping;
}

const SecondShoppingHeader: FC<IShoppingHeader> = ({ headerData }: IShoppingHeader) => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div id="secondShoppingHeader">
      <div className="titleHeader">
        <div className="styleTitle">
          <span className="bigStyleTitle">Sin fecha</span>
          {` -Confirmados / Activos (${headerData?.unDate?.quantity || 0})`}{' '}
        </div>
      </div>
      <div className="titleHeader">
        <div className="styleTitle">
          <span className="bigStyleTitle">Con fecha</span>
          {` -Proceso de entrega (${headerData?.withDate?.quantity || 0})`}
        </div>
      </div>
      <div className="titleHeader">
        <div className="styleTitle">
          <span className="bigStyleTitle">Atrasados</span>
          {` (${headerData?.lateDate?.quantity || 0})`}
        </div>
      </div>
    </div>
  );
};

export default SecondShoppingHeader;
